import * as React from 'react';
import {
    AdServerTagSideEnum,
    IDemandSupplyTransaction,
    IDataPointOverviewMetricsData
} from "@leap4/entities-discrepancy-common";
import {DynamicDatagrid, Grid, IDataGridProps, MuiDataGrid, Typography, Paper} from "@leap4/frontend";

import {EntitiesProperties} from "../../../../utils/enums";
import {useContext, useEffect, useState} from "react";
import {UserViewsContext} from "../../../../contexts/userViewsContext";
import {generateColumn} from "../../common/tableColumnsGenerator";

type GridColDef = MuiDataGrid.GridColDef;
export interface IAdServerRowConnectedTag {
    id: string
    name: string
    campaignId: string
    revenue: number,
    cost: number
    impressions: number,
    dataPoint: string
    adServer: string,
    metrics: IDemandSupplyTransaction[]
}

export interface IDataPointTagsTableProps extends Partial<IDataGridProps> {
    metrics: IDataPointOverviewMetricsData,
    loading: boolean,
    compareData: IDataPointOverviewMetricsData
}

export default function DataPointTagsTable({
                                               metrics,
                                               loading,
                                               refreshFunc,
                                               compareData
                                           }: IDataPointTagsTableProps) {
    const {userViews} = useContext(UserViewsContext)
    const {
        NAME, CAMPAIGN_ID
    } = EntitiesProperties.NOT_NUMERIC

    const [columns, setColumns] = useState<GridColDef[]>([])
    useEffect(() => {
        const userPresetColumns = userViews.activePreset.tableViews.map(view => generateColumn(view, compareData))
        const preConstantColumns = [NAME, CAMPAIGN_ID].map(view => generateColumn(view, compareData))
        setColumns([...preConstantColumns, ...userPresetColumns])
    }, [userViews, compareData])

    function createRowData(item: any) {
        const {totals} = item;
        const profit = totals.revenue - totals.cost;
        return {
            id: item._id,
            name: item.name,
            campaignId: item.campaignId,
            cost: totals.cost,
            revenue: totals.revenue,
            impressions: totals.impressions,
            requests: totals.requests,
            completion: totals.completion,
            cpm: totals?.impressions === 0 ? 0 : (totals?.cost / totals?.impressions) * 1000,
            rpm: totals?.impressions === 0 ? 0 : (totals?.revenue / totals?.impressions) * 1000,
            vcr: totals?.impressions === 0 ? 0 : (totals?.completion / totals?.impressions) * 100,
            profit,
            profitPercent: profit / totals.revenue * 100,
            adFillRate: ((totals?.impressions || 0) / (totals?.requests)) * 100,
            fillRate: ((totals?.impressions || 0) / (totals?.incomingRequests)) * 100,
            netProfit: totals?.netRevenue - totals?.netCost,
            incomingRequests: totals?.incomingRequests,
            ...totals
        }
    }

    const supplyRows = metrics.tags.filter(x => x.side === AdServerTagSideEnum.SUPPLY).map(row => createRowData(row)).sort((a, b) => b.revenue > a.revenue ? 1 : -1);
    const demandRows = metrics.tags.filter(x => x.side === AdServerTagSideEnum.DEMAND).map(row => createRowData(row)).sort((a, b) => b.revenue > a.revenue ? 1 : -1);

    return (
        <>
            <Grid container justifyContent={"space-around"}>
                <Grid item xs={12}>
                    <Typography variant={"overline"}>Supply Tags</Typography>
                    <Paper elevation={5} style={{ borderRadius: "16px"}}>
                        <DynamicDatagrid rows={supplyRows}
                                         columns={columns}
                                         loading={loading}
                                         loadError={false}
                                         refreshFunc={refreshFunc}
                                         pageSize={100}
                                         style={{minHeight: `75vh`, width: '100%'}}
                        />
                    </Paper>
                </Grid>
            </Grid>
            <Grid container sm={12}>
                <Grid item xs={12}>
                    <Typography variant={"overline"}>Demand Tags</Typography>
                    <Paper elevation={5} style={{ borderRadius: "16px"}}>
                        <DynamicDatagrid rows={demandRows}
                                         columns={columns}
                                         loading={loading}
                                         loadError={false}
                                         refreshFunc={refreshFunc}
                                         pageSize={100}
                                         style={{minHeight: `75vh`, width: '100%'}}
                        /></Paper>
                </Grid>
            </Grid>
        </>
    );
}
